/**
 * @generated SignedSource<<89c7ee41bb1ff524380eccf219b93b44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedPromoModuleSecondary_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly messages: {
    readonly items: ReadonlyArray<{
      readonly cmsId: number | null;
      readonly linkData: {
        readonly path: string | null;
      };
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedPromoModulePromoItem_promotion">;
    } | null> | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "HpSharedPromoModuleSecondary_componentModule";
};
export type HpSharedPromoModuleSecondary_componentModule$key = {
  readonly " $data"?: HpSharedPromoModuleSecondary_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedPromoModuleSecondary_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedPromoModuleSecondary_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PromoItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedPromoModulePromoItem_promotion"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PromoModule",
  "abstractKey": null
};

(node as any).hash = "9a0c06a5d28d14606203ba3c5a08db31";

export default node;
